"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowsApi = void 0;
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class WorkflowsApi extends runtime.BaseAPI {
    /**
     * Update Settings APIKeys
     * Update Settings APIKeys
     */
    updateSettingsApikeysRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsApikeys().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_apikeys`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings APIKeys
     * Update Settings APIKeys
     */
    updateSettingsApikeys(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsApikeysRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create, update, or delete areas and associate device positions with them
     * Update area settings
     */
    updateSettingsAreasRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsAreas().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_areas`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create, update, or delete areas and associate device positions with them
     * Update area settings
     */
    updateSettingsAreas(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsAreasRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update attendance capacity settings
     * Update Attendance Capacity
     */
    updateSettingsAttendanceCapacityRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsAttendanceCapacity().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_attendance_capacity`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update attendance capacity settings
     * Update Attendance Capacity
     */
    updateSettingsAttendanceCapacity(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsAttendanceCapacityRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Settings Auth Providers
     * Update Settings Auth Providers
     */
    updateSettingsAuthProvidersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsAuthProviders().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_auth_providers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings Auth Providers
     * Update Settings Auth Providers
     */
    updateSettingsAuthProviders(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsAuthProvidersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Settings Branches
     * Update Settings Branches
     */
    updateSettingsBranchesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsBranches().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_branches`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings Branches
     * Update Settings Branches
     */
    updateSettingsBranches(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsBranchesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update business hours and calendar exception settings
     * Update business hour settings
     */
    updateSettingsBusinessHourRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsBusinessHour().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_business_hour`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update business hours and calendar exception settings
     * Update business hour settings
     */
    updateSettingsBusinessHour(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsBusinessHourRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update device-level sleep time settings for meeting room shortening/cancellation notifications. Configures active and sleep times for each day of the week at the device level.  **Priority**: Device-level settings OVERRIDE tenant-level settings for the specific device.  Wake time = start of active period (when notifications are enabled) Sleep time = end of active period (when notifications are disabled)  Validation rules: - All time values must be in HH:MM format - Time range: 00:00 to 24:00 - Wake time must be <= Sleep time for each day - Sleep time must be >= Wake time for each day - Invalid values will be rejected with 400 error - device_position_id must exist and belong to the specified tenant
     * Update Butlr Sleep Settings for Device
     */
    updateSettingsButlrSleepDeviceRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsButlrSleepDevice().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_butlr_sleep_device`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update device-level sleep time settings for meeting room shortening/cancellation notifications. Configures active and sleep times for each day of the week at the device level.  **Priority**: Device-level settings OVERRIDE tenant-level settings for the specific device.  Wake time = start of active period (when notifications are enabled) Sleep time = end of active period (when notifications are disabled)  Validation rules: - All time values must be in HH:MM format - Time range: 00:00 to 24:00 - Wake time must be <= Sleep time for each day - Sleep time must be >= Wake time for each day - Invalid values will be rejected with 400 error - device_position_id must exist and belong to the specified tenant
     * Update Butlr Sleep Settings for Device
     */
    updateSettingsButlrSleepDevice(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsButlrSleepDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update tenant-level sleep time settings for meeting room shortening/cancellation notifications. Configures active and sleep times for each day of the week.  Wake time = start of active period (when notifications are enabled) Sleep time = end of active period (when notifications are disabled)  Validation rules: - All time values must be in HH:MM format - Time range: 00:00 to 24:00 - Wake time must be <= Sleep time for each day - Sleep time must be >= Wake time for each day - Invalid values will be rejected with 400 error
     * Update Butlr Sleep Settings for Tenant
     */
    updateSettingsButlrSleepTenantRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsButlrSleepTenant().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_butlr_sleep_tenant`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update tenant-level sleep time settings for meeting room shortening/cancellation notifications. Configures active and sleep times for each day of the week.  Wake time = start of active period (when notifications are enabled) Sleep time = end of active period (when notifications are disabled)  Validation rules: - All time values must be in HH:MM format - Time range: 00:00 to 24:00 - Wake time must be <= Sleep time for each day - Sleep time must be >= Wake time for each day - Invalid values will be rejected with 400 error
     * Update Butlr Sleep Settings for Tenant
     */
    updateSettingsButlrSleepTenant(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsButlrSleepTenantRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates zone settings for camera devices
     * Update camera zones settings for Meraki and Verkada devices
     */
    updateSettingsCameraZonesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsCameraZones().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_camera_zones`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates zone settings for camera devices
     * Update camera zones settings for Meraki and Verkada devices
     */
    updateSettingsCameraZones(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsCameraZonesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update or create device positions
     * Update device positions
     */
    updateSettingsDevicePositionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsDevicePositions().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_device_positions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update or create device positions
     * Update device positions
     */
    updateSettingsDevicePositions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsDevicePositionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Settings Employees
     * Update Settings Employees
     */
    updateSettingsEmployeesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsEmployees().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_employees`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings Employees
     * Update Settings Employees
     */
    updateSettingsEmployees(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsEmployeesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Settings Floors
     * Update Settings Floors
     */
    updateSettingsFloorsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsFloors().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_floors`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings Floors
     * Update Settings Floors
     */
    updateSettingsFloors(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsFloorsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Settings Organizations
     * Update Settings Organizations
     */
    updateSettingsOrganizationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsOrganizations().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_organizations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update Settings Organizations
     * Update Settings Organizations
     */
    updateSettingsOrganizations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsOrganizationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates settings for people counts including format and thresholds
     * Update people counts settings
     */
    updateSettingsPeopleCountsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsPeopleCounts().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_people_counts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates settings for people counts including format and thresholds
     * Update people counts settings
     */
    updateSettingsPeopleCounts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsPeopleCountsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update thresholds for temperature, humidity, carbon dioxide, and noise levels for floors
     * Update sensor data thresholds
     */
    updateSettingsSensorDataThresholdsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsSensorDataThresholds().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_sensor_data_thresholds`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update thresholds for temperature, humidity, carbon dioxide, and noise levels for floors
     * Update sensor data thresholds
     */
    updateSettingsSensorDataThresholds(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsSensorDataThresholdsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates or creates signage components configuration
     * Update signage components settings
     */
    updateSettingsSignageComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsSignageComponents().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_signage_components`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates or creates signage components configuration
     * Update signage components settings
     */
    updateSettingsSignageComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsSignageComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update signage notices settings
     */
    updateSettingsSignageNoticesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_signage_notices`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update signage notices settings
     */
    updateSettingsSignageNotices() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.updateSettingsSignageNoticesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update tenant-level configuration settings including: - Tenant name - Schedule tool integration - Room notice messages - IP address restrictions - Password login enablement (is_password_login)  The is_password_login field (boolean, nullable) controls whether password-based authentication is allowed for all users in the tenant. NULL or TRUE = enabled, FALSE = disabled.
     * Update Settings Tenants
     */
    updateSettingsTenantsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsTenants().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_tenants`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update tenant-level configuration settings including: - Tenant name - Schedule tool integration - Room notice messages - IP address restrictions - Password login enablement (is_password_login)  The is_password_login field (boolean, nullable) controls whether password-based authentication is allowed for all users in the tenant. NULL or TRUE = enabled, FALSE = disabled.
     * Update Settings Tenants
     */
    updateSettingsTenants(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsTenantsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates the Verkada devices settings for a given tenant
     * Update Verkada devices settings
     */
    updateSettingsVerkadaDevicesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsVerkadaDevices().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_verkada_devices`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Updates the Verkada devices settings for a given tenant
     * Update Verkada devices settings
     */
    updateSettingsVerkadaDevices(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsVerkadaDevicesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update tenant-level analysis time settings for calculating meeting room reservation and usage rates
     * Update Meeting Room Analysis Time Settings
     */
    updateSettingsMeetingRoomAnalysisTimeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiPostWorkflowRequest'] == null) {
                throw new runtime.RequiredError('apiPostWorkflowRequest', 'Required parameter "apiPostWorkflowRequest" was null or undefined when calling updateSettingsMeetingRoomAnalysisTime().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/workflows/update_settings_meeting_room_analysis_time`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiPostWorkflowRequestToJSON)(requestParameters['apiPostWorkflowRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiPostWorkflowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update tenant-level analysis time settings for calculating meeting room reservation and usage rates
     * Update Meeting Room Analysis Time Settings
     */
    updateSettingsMeetingRoomAnalysisTime(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSettingsMeetingRoomAnalysisTimeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.WorkflowsApi = WorkflowsApi;
